import { ChartLabelController as controller } from './chartLabel.controller';
import template from './chartLabel.html';

export const chartLabelComponent = {
  name: 'chartLabelComponent',
  restrict: 'E',
  transclude: true,
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    onToggleFilter: '&',
    model: '<',
    isChecked: '<'
  }
};
